'use client'

import type { Address, ChainId } from '@morpho-org/blue-sdk'

import { skipToken, useQuery } from '@tanstack/react-query'

import { orpc } from '@/lib/orpc/client'

import { toVaultV1ActionPanelData } from './vaultV1ActionPanelData'

/** Reads `vaultV1.actionPanel` from the client: the position-manager dialogs and the recap. */
export function useVaultV1ActionPanelData({
  vaultAddress,
  chainId
}: {
  vaultAddress: Address
  chainId: ChainId | undefined
}) {
  const { data, isLoading, error } = useQuery(
    orpc.vaultV1.actionPanel.queryOptions({
      input: chainId === undefined ? skipToken : { chainId, address: vaultAddress }
    })
  )

  const vaultData =
    data && chainId !== undefined ? toVaultV1ActionPanelData(data, chainId) : undefined

  return { vaultData, isLoading, error }
}
